<mat-card>{{'notifications' | translate}}</mat-card>


<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
      <mat-form-field  appearance="standard">
          <mat-label>{{'users' | translate}}</mat-label>
         
          <mat-select multiple [disabled]="selectAll" [(ngModel)]="selectedCustomers">
            <!-- <app-select-check-all [model]="$any(form).controls['customer']" [values]="customers">
			</app-select-check-all> -->
            <mat-option *ngFor="let customer of customers" [value]="customer.id">
              {{customer.fullName}}
            </mat-option>
          </mat-select>
          
        </mat-form-field>
  </mat-grid-tile >
  <mat-grid-tile colspan="1">
    <mat-checkbox class="example-margin" [(ngModel)]="selectAll">{{'all' | translate}}</mat-checkbox>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'title' | translate}}</mat-label>
            <input matInput required [(ngModel)]="title">
            <!-- <mat-error *ngIf="title1.invalid">{{'requiredField' | translate}}</mat-error> -->
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-grid-list cols="5" rowHeight="70px">
    <mat-grid-tile colspan="1"></mat-grid-tile>
    <mat-grid-tile colspan="2">
        <mat-form-field  appearance="standard">
            <mat-label>{{'body' | translate}}</mat-label>
            <input matInput [(ngModel)]="body">
            <!-- <mat-error *ngIf="body1.invalid">{{'requiredField' | translate}}</mat-error> -->
          </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
  
    
  <mat-grid-list cols="4" rowHeight="100px">
    <mat-grid-tile></mat-grid-tile>
    <mat-grid-tile>
      
        <!-- [disabled]="title1.invalid || body1.invalid" -->
        <button mat-raised-button color="primary" (click)="submit()" 
        
        >
            <mat-icon>done</mat-icon>
            {{'send' | translate}}</button>
    </mat-grid-tile>
  </mat-grid-list>

  <app-matspinner [overlay]="spinnerOverlay"></app-matspinner>
